import { render, staticRenderFns } from "./CustomBarChart.vue?vue&type=template&id=74121fb4&scoped=true&"
import script from "./CustomBarChart.vue?vue&type=script&lang=js&"
export * from "./CustomBarChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomBarChart.vue?vue&type=style&index=0&id=74121fb4&prod&lang=scss&scoped=true&"
import style1 from "./CustomBarChart.vue?vue&type=style&index=1&id=74121fb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74121fb4",
  null
  
)

export default component.exports